import React from 'react';

const PrivacyPolicy = () => (
  <div className="legal-page">
    <h1>Privacy Policy</h1>
    <p><strong>Effective Date:</strong> April 30, 2025</p>
    <p>
      Snappo LLC ("Snappo," "we," "our," or "us") respects your privacy and is committed to protecting it through this Privacy Policy. This policy explains how we collect, use, disclose, and safeguard your information when you use our services, including our website, mobile application, and event-based media-sharing platform (collectively, the "Services").
    </p>

    <p>
      This policy applies globally and includes provisions to comply with applicable laws including the General Data Protection Regulation (GDPR), the California Consumer Privacy Act (CCPA), and other regional privacy laws.
    </p>

    <hr />
    <h2>1. Information We Collect</h2>
    <p>We collect the following categories of personal data:</p>
    <ul>
      <li><strong>Personal identifiers:</strong> Name, email address, phone number, event access codes, and account credentials.</li>
      <li><strong>Media uploads:</strong> Photos, videos, audio recordings, and comments submitted to events.</li>
    </ul>

    <hr />
    <h2>2. How We Use Your Information</h2>
    <p>We use your information to:</p>
    <ul>
      <li>Provide access to private event feeds and media uploads</li>
      <li>Facilitate file downloads and content sharing</li>
      <li>Allow users to download and share uploaded content</li>
      <li>Improve user experience and service functionality</li>
    </ul>
    
    <hr />
    <h2>3. Legal Basis for Processing (GDPR)</h2>
    <p>If you are located in the European Economic Area (EEA), we process your data under the following legal bases:</p>
    <ul>
      <li><strong>Consent</strong> (e.g., uploading content or registering for events)</li>
      <li><strong>Contractual necessity</strong> (e.g., providing access to event feeds)</li>
      <li><strong>Legitimate interests</strong> (e.g., ensuring security, improving services)</li>
    </ul>
    
    <hr />
    <h2>4. Downloadable Content and User Uploads</h2>
    <p>By uploading content (photos, videos, voice notes) to Snappo, you:</p>
    <ul>
      <li>Confirm you have the right to upload and share the material</li>
      <li>Grant Snappo a non-exclusive, royalty-free license to host, display, and allow downloads of your content within the context of the event</li>
      <li>Understand that content may be downloadable by the event host and participants unless otherwise restricted</li>
    </ul>
    <p>We reserve the right to remove content that violates our Terms of Service or applicable law.</p>

    <hr />
    <h2>5. Data Sharing</h2>
    <p>We may share data with:</p>
    <ul>
      <li><strong>Event hosts</strong> (e.g., couples or organizers) for their private album or download</li>
      <li><strong>Service providers</strong> (e.g., Twilio for messaging, Google for storage and analytics)</li>
      <li><strong>Legal authorities</strong> when required</li>
      <li><strong>Business successors</strong> in the case of acquisition, merger, or reorganization</li>
    </ul>
    <p>We do not sell your personal data.</p>

    
    <hr />
    <h2>6. International Data Transfers</h2>
    <p>Snappo LLC is based in the United States. If you are accessing our Services from outside the U.S., your data may be transferred to, stored, and processed in the U.S. We implement appropriate safeguards such as Standard Contractual Clauses (SCCs) to protect your data.</p>

    
    <hr />
    <h2>7. Your Rights</h2>
    <p>Depending on your location, you may have rights to:</p>
    <ul>
      <li>Access the personal data we hold about you</li>
      <li>Request correction or deletion</li>
      <li>Withdraw consent at any time</li>
      <li>Object to or restrict processing</li>
      <li>Request data portability</li>
    </ul>
    <p>To exercise these rights, email us at <a href="mailto:info@snappo.io">info@snappo.io</a>.</p>
    
    <hr />
    <h2>8. Data Security and Retention</h2>
    <p>We take reasonable steps to protect your information using encryption, access controls, and secure infrastructure. We retain your information as long as needed for the purposes outlined in this policy unless a longer retention is required by law.</p>
    
    <hr />
    <h2>9. Children’s Privacy</h2>
    <p>Snappo does not knowingly collect information from individuals under the age of 13. If we discover that a child under 13 has submitted data, we will delete it promptly.</p>
    
    <hr />
    <h2>10. Third-Party Links</h2>
    <p>Our services may link to third-party websites or services. This policy does not cover those third parties. We encourage you to review their privacy practices.</p>

    <hr />
    <h2>11. Changes to This Privacy Policy</h2>
    <p>We may update this policy periodically. Material changes will be posted on our website and, when appropriate, notified by email. Your continued use of the Services after changes indicates your acceptance.</p>

    <hr />
    <h2>12. Contact Us</h2>
    <p>For any questions or concerns, please contact:</p>
    <address>
      Snappo LLC<br />
      Arizona<br />
      📧 <a href="mailto:info@snappo.io">info@snappo.io</a>
    </address>
  </div>
);

export default PrivacyPolicy;
